// Access the strings used on the insertEmail page.
export const t_insertUsername = {
  title: "signup.insertUsername.title",
  subtitle: "signup.insertUsername.subtitle",
  emailPlaceholder: "signup.insertUsername.emailPlaceholder",
};
